import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DATE_FORMAT } from 'src/constants/common.constants';

dayjs.extend(duration);
dayjs.extend(relativeTime);

export const ActivityDate: React.VFC<{ date: string }> = ({ date }) => {
    const duration = useMemo(() => {
        const from = dayjs(date);
        const now = dayjs();

        const diff = now.diff(from, 'd');
        if (diff < 1) {
            return from.from(dayjs());
        }
        return from.format(DATE_FORMAT);
    }, [date]);

    return <>{duration}</>;
};
